import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import styles from './AccordionItem.module.css';

const AccordionItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.accordionItem}>
            <button className={styles.header} onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen}>
                <span className={styles.question}>{question}</span>
                <FiChevronDown className={`${styles.chevron} ${isOpen ? styles.open : ''}`} />
            </button>
            <div className={`${styles.body} ${isOpen ? styles.open : ''}`}>
                <div className={styles.content}>
                    {answer}
                </div>
            </div>
        </div>
    );
};
export default AccordionItem;
